import { t } from "i18next";
import i18n from "src/core/configs/i18n";
import { schoolMockData } from "src/services/school-mock-data/school-mock-data";
import { GrLocation } from "react-icons/gr";
import {
  HiHeart,
  HiOutlineUserGroup,
  HiOutlineStar,
  HiOutlineCash,
} from "react-icons/hi";
import { appRoutesObj } from "src/app.paths";
import { useNavigate } from "react-router-dom";

function FavoriteSchoolsComponent() {
  const navigate = useNavigate();
  const dummyData = schoolMockData.slice(0, 2);
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col gap-3 mt-8 w-[754px] mobile:w-auto items-start mobile:items-center"
    >
      {dummyData.map((item, index) => (
        <div key={index} dir={i18n.language === "ar" ? "rtl" : "ltr"}>
          <div
            onClick={() =>
              navigate(appRoutesObj.getSchoolDetailsPageUrl(item.id.toString()))
            }
            className={`flex flex-row justify-start items-start mobile:items-center w-[754px] laptop:w-[680px] tablet:w-[550px] ${
              i18n.language === "ar" ? "gap-[110px]" : "gap-[90px]"
            }  rounded-2xl shadow-[rgba(0,_0,_0,_0.05)0px_0px_20px_0px] bg-zinc50 px-3 mobile:hidden tablet:hidden cursor-pointer`}
          >
            <div className="flex flex-row gap-[13px]">
              <HiHeart
                className={`absolute ${
                  i18n.language === "ar" ? "mr-1" : "ml-1"
                } mt-1 text-2xl text-tart-500 cursor-pointer`}
              />
              <img
                src={item.images[0]}
                className="w-[176px] h-[170px] laptop:w-[150px] tablet:w-[140px] rounded-lg"
                alt=""
              />
              <div className="flex flex-col gap-2.5">
                <p className="font-arBold text-xl text-zinc700">
                  {i18n.language === "ar" ? item.schoolName : item.schoolNameEn}
                </p>
                <p className="font-arRegular text-zinc700 w-[299.5px]">
                  {i18n.language === "ar"
                    ? item.description
                    : item.descriptionEn}
                </p>
                <div className="flex items-center gap-1">
                  <HiOutlineUserGroup size={14} className="text-zinc700 mb-1" />
                  <p className="text-sm text-zinc700 font-arRegular">
                    {item.numberOfStudents.toString()}
                  </p>
                </div>
                <div className="flex items-center gap-1">
                  <GrLocation size={14} className="text-zinc700" />
                  <p className="text-sm text-zinc700 font-arRegular">
                    {i18n.language === "ar" ? item.district : item.districtEn} ،{" "}
                    {i18n.language === "ar" ? item.city : item.cityEn} ،{" "}
                    {i18n.language === "ar" ? item.country : item.countryEn}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`flex flex-col items-end ${
                i18n.language === "ar" ? "w-[128px]" : "w-[150px]"
              } gap-[105px]`}
            >
              <div className=" flex flex-row gap-2 justify-center items-center w-20 h-8 rounded-lg bg-tart500 backdrop-blur-md">
                <HiOutlineStar className="text-2xl text-zinc-50 cursor-pointer" />
                <p className="text-sm text-zinc-50 font-arMedium mt-1.5">
                  {item.rating}
                </p>
              </div>
              <div className="flex">
                <HiOutlineCash className="text-green600 w-[22px] h-5" />
                <p className="text-base font-arRegular text-green600">
                  {t("resultSchoolCard.component.startfrom")}{" "}
                  {item.price.toString()}
                </p>
              </div>
            </div>
          </div>
          {/* mobile & tablet */}
          <div
            onClick={() =>
              navigate(appRoutesObj.getSchoolDetailsPageUrl(item.id.toString()))
            }
            className="flex mobile:max-w-[359px] w-screen tablet:w-[420px] laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden px-3 pb-4 cursor-pointer"
          >
            <div className="flex flex-row gap-[13px]">
              <HiHeart
                className={`absolute ${
                  i18n.language === "ar" ? "mr-1" : "ml-1"
                } mt-1 text-2xl text-tart-500 cursor-pointer`}
              />
              <img
                src={item.images[0]}
                className="mobile:w-[127px] tablet:w-[200px] h-[185px] rounded-lg"
                alt=""
              />
              <div className="flex flex-col gap-3">
                <p className="font-arBold text-base text-zinc700">
                  {i18n.language === "ar" ? item.schoolName : item.schoolNameEn}
                </p>
                <div
                  className={`flex flex-row gap-1 justify-center items-center w-[58px] h-6 rounded bg-tart500 backdrop-blur-md ${
                    i18n.language === "ar" ? "pl-4 pr-2" : "pr-4 pl-2"
                  } `}
                >
                  <HiOutlineStar className="w-[16px] h-[16px] text-zinc-50 cursor-pointer" />
                  <p className="text-xs text-zinc-50 font-arMedium mt-1">
                    {item.rating}
                  </p>
                </div>
                <p className="font-arRegular text-zinc700 w-[207px] tablet:w-[280px] text-sm line-clamp-3">
                  {i18n.language === "ar"
                    ? item.description
                    : item.descriptionEn}
                </p>
                <div className="flex items-center gap-1">
                  <GrLocation size={14} className="text-zinc700" />
                  <p className="text-sm text-zinc700 font-arRegular">
                    {i18n.language === "ar" ? item.district : item.districtEn}،{" "}
                    {i18n.language === "ar" ? item.city : item.cityEn} ،
                    {i18n.language === "ar" ? item.country : item.countryEn}
                  </p>
                </div>
                <div className="flex">
                  <HiOutlineCash className="text-green600 w-[22px] h-5" />
                  <p className="text-base font-arRegular text-green600">
                    {t("resultSchoolCard.component.startfrom")}
                    {item.price.toString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr className="mx-3 tablet:hidden laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden"></hr>
        </div>
      ))}
    </div>
  );
}

export default FavoriteSchoolsComponent;
